import React, { PropsWithChildren } from 'react';
import { TaskCard, TaskCardProps } from 'components/TaskCard/TaskCard';
import { ReactComponent as ToDoIcon } from 'assets/icons/ToDoIcon.svg';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { DEFAULT_ASSESSMENT_CARD_NAME } from 'features/assessments/constants';

export interface AssessmentsTaskCardProps
  extends Omit<TaskCardProps, 'taskTypeLabel' | 'icon' | 'taskName'> {
  assessmentName?: string;
}

export const GuidingCareAssessmentsTaskCard = ({
  assessmentName,
  careProgramName,
  isCompleted,
  onClick,
  taskTypeLabelColor,
  taskCardLabeledby,
  children,
}: PropsWithChildren<AssessmentsTaskCardProps>) => {
  const { translation } = useTranslationContext();
  const label = translation('checklist_task_type_check_in') || 'Check In';
  const name = assessmentName ?? DEFAULT_ASSESSMENT_CARD_NAME;

  return (
    <TaskCard
      icon={<SvgIcon component={ToDoIcon} />}
      taskTypeLabel={label}
      taskTypeLabelColor={taskTypeLabelColor}
      taskName={name}
      careProgramName={careProgramName}
      isCompleted={isCompleted}
      onClick={onClick}
      taskCardLabeledby={taskCardLabeledby}
    >
      {children}
    </TaskCard>
  );
};
